module.exports = __webpack_public_path__ + "static/media/play.65e9a280.svg";